import OneClickHeading from './OneClickHeading';
export default OneClickHeading;